module.exports = __webpack_public_path__ + "img/igp.cbdc43be.webp";